const technologys = [
     {
          name: 'HTML',
          porcentage: '95%',
     },
     {
          name: 'CSS',
          porcentage: '87%',
     },
     {
          name: 'React',
          porcentage: '80%',
     },
     {
          name: 'React Native',
          porcentage: '65%',
     },
     {
          name: 'Next',
          porcentage: '70%',
     },
     {
          name: 'Redux',
          porcentage: '80%',
     },
     {
          name: 'JavaScript',
          porcentage: '80%',
     },
     {
          name: 'TypeScript',
          porcentage: '55%',
     },
     {
          name: 'NodeJs',
          porcentage: '75%',
     },
     {
          name: 'Express',
          porcentage: '70%',
     },
     {
          name: 'Sequelize',
          porcentage: '70%',
     },
     {
          name: 'PostgreSQL',
          porcentage: '60%',
     },
     {
          name: 'MongoDB',
          porcentage: '40%',
     },
     {
          name: 'SQL',
          porcentage: '60%',
     },
];

export default technologys;
